import { useMap } from 'react-map-gl/mapbox';

import { useMultiFlightMap } from '../../MultiFlightMap.context';
import {
  ButtonGroupStyled,
  ControlButtonStyled,
  NavigationControlContainerStyled
} from './CustomNavigationControl.styled';

interface CustomNavigationControlProps {
  mapId: string;
  position?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
}

export function CustomNavigationControl({ mapId, position = 'top-right' }: CustomNavigationControlProps) {
  const { [mapId]: map } = useMap();
  const { centerElementsOnTheMap } = useMultiFlightMap();

  const handleZoomIn = () => {
    if (map) {
      map.zoomIn();
    }
  };

  const handleZoomOut = () => {
    if (map) {
      map.zoomOut();
    }
  };

  return (
    <NavigationControlContainerStyled position={position}>
      <ButtonGroupStyled>
        <ControlButtonStyled onClick={() => centerElementsOnTheMap()}>
          <span className="fa-regular fa-arrows-to-dot" />
        </ControlButtonStyled>
      </ButtonGroupStyled>
      <ButtonGroupStyled>
        <ControlButtonStyled onClick={handleZoomIn}>
          <span className="fa-regular fa-plus" />
        </ControlButtonStyled>
        <ControlButtonStyled onClick={handleZoomOut}>
          <span className="fa-regular fa-minus" />
        </ControlButtonStyled>
      </ButtonGroupStyled>
    </NavigationControlContainerStyled>
  );
}

export default CustomNavigationControl;
